var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"display",attrs:{"id":"viewport"},on:{"click":function($event){return _vm.handlerView($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }